import { render } from "./NotificationBatchEditPane.vue?vue&type=template&id=20370f20&ts=true"
import script from "./NotificationBatchEditPane.vue?vue&type=script&lang=ts"
export * from "./NotificationBatchEditPane.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__